(() => {
  const TARGET = 50;
  let scheduled = false;
  let cartSnapshot = null;
  let cartFetchInFlight = null;
  let lastCartFetch = 0;

  const money = (n) => new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format(n);
  const moneyCents = (cents) => money((Number(cents) || 0) / 100);

  const readTotal = (drawer) => {
    const el = drawer.querySelector('[data-cart-subtotal], .cart-totals__total-value');
    if (!el) return null;
    const raw = (el.textContent || '').replace(/,/g,'');
    const match = raw.match(/-?\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : null;
  };

  const ensureStyles = () => {
    if (document.getElementById('dos-cart-clarity-styles')) return;
    const style = document.createElement('style');
    style.id = 'dos-cart-clarity-styles';
    style.textContent = `
      .dos-total-savings{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:12px 14px;border-radius:14px;background:rgba(111,38,52,.07);color:#6f2634;font-weight:800}
      .dos-total-savings__label{font-size:.9rem}.dos-total-savings__value{font-size:1rem;font-weight:900;white-space:nowrap}
      .cart-drawer__summary .dos-total-savings{padding:10px 12px;border-radius:12px}
      .dos-cart-media-link{cursor:pointer}
      .dos-cart-media-link:focus-visible{outline:3px solid #6f2634;outline-offset:3px;border-radius:14px}
      .cart-drawer__items .quantity-selector,.cart-page__items .quantity-selector{color:#2d211b!important}
      .cart-drawer__items .quantity-selector button,.cart-page__items .quantity-selector button,
      .cart-drawer__items .quantity-selector [role="button"],.cart-page__items .quantity-selector [role="button"]{color:#6f2634!important;opacity:1!important;-webkit-text-fill-color:#6f2634!important}
      .cart-drawer__items .quantity-selector input,.cart-page__items .quantity-selector input,
      .cart-drawer__items .quantity-selector input[type="number"],.cart-page__items .quantity-selector input[type="number"]{color:#2d211b!important;opacity:1!important;-webkit-text-fill-color:#2d211b!important}
      .cart-drawer__items .quantity-selector svg,.cart-page__items .quantity-selector svg,
      .cart-drawer__items .cart-items__remove svg,.cart-page__items .cart-items__remove svg{color:#6f2634!important;opacity:1!important}
      .cart-drawer__items .cart-items__remove,.cart-page__items .cart-items__remove,
      .cart-drawer__items button[name="remove"],.cart-page__items button[name="remove"]{color:#6f2634!important;opacity:1!important;-webkit-text-fill-color:#6f2634!important}
      .cart-drawer__items .cart-items__remove *, .cart-page__items .cart-items__remove *{opacity:1!important}
    `;
    document.head.appendChild(style);
  };

  const renderSavings = () => {
    ensureStyles();
    const savingsCents = Number(cartSnapshot?.total_discount || 0);
    document.querySelectorAll('.cart-totals__container').forEach((container) => {
      let row = container.querySelector('[data-dos-total-savings]');
      if (savingsCents <= 0) { row?.remove(); return; }
      if (!row) {
        row = document.createElement('span');
        row.className = 'cart-totals__item dos-total-savings';
        row.setAttribute('data-dos-total-savings','');
        row.innerHTML = '<span class="dos-total-savings__label">Total savings</span><strong class="dos-total-savings__value"></strong>';
        container.prepend(row);
      }
      const value = row.querySelector('.dos-total-savings__value');
      if (value) value.textContent = `−${moneyCents(savingsCents)}`;
      row.setAttribute('aria-label', `Total savings ${moneyCents(savingsCents)}`);
    });
  };

  const enableImageDetails = () => {
    document.querySelectorAll('.cart-items__table-row').forEach((row) => {
      const title = row.querySelector('.cart-items__title[href]');
      const media = row.querySelector('.cart-items__media-container');
      if (!title || !media) return;
      if (media.closest('a[href]')) return;
      media.classList.add('dos-cart-media-link');
      media.dataset.dosProductUrl = title.href;
      media.setAttribute('role','link');
      media.setAttribute('tabindex','0');
      media.setAttribute('aria-label', `View ${title.textContent.trim()} details`);
    });
  };

  const removeOldViewDetails = () => {
    document.querySelectorAll('[data-dos-view-details], .dos-view-details').forEach((el) => el.remove());
  };

  const renderCheckoutReassurance = () => {
    document.querySelectorAll('.cart__ctas').forEach((ctas) => {
      if (ctas.querySelector('[data-dos-checkout-reassurance]')) return;
      const checkout = ctas.querySelector('.cart__checkout-button');
      if (!checkout) return;
      const trust = document.createElement('div');
      trust.className = 'dos-checkout-reassurance';
      trust.setAttribute('data-dos-checkout-reassurance','');
      trust.innerHTML = `
        <div class="dos-checkout-reassurance__title">Ready when you are.</div>
        <div class="dos-checkout-reassurance__items">
          <span>🔒 Secure checkout</span>
          <span>✓ 30-day no-hassle returns</span>
          <span>✓ Final shipping & taxes shown before payment</span>
        </div>`;
      ctas.insertBefore(trust, checkout);
    });
  };

  const fetchCart = async (force = false) => {
    const now = Date.now();
    if (!force && cartSnapshot && now - lastCartFetch < 700) return cartSnapshot;
    if (cartFetchInFlight) return cartFetchInFlight;
    cartFetchInFlight = fetch('/cart.js',{headers:{'Accept':'application/json'},cache:'no-store'})
      .then((response) => { if (!response.ok) throw new Error('Unable to read cart'); return response.json(); })
      .then((cart) => { cartSnapshot = cart; lastCartFetch = Date.now(); renderSavings(); return cart; })
      .catch(() => cartSnapshot)
      .finally(() => { cartFetchInFlight = null; });
    return cartFetchInFlight;
  };

  const render = () => {
    scheduled = false;
    ensureStyles();
    document.querySelectorAll('.cart-drawer__dialog').forEach((drawer) => {
      const summary = drawer.querySelector('.cart-drawer__summary');
      if (!summary) return;
      const total = readTotal(drawer);
      if (total === null || Number.isNaN(total)) return;
      const centsKey = String(Math.round(total * 100));
      let box = summary.querySelector('[data-dos-drawer-confidence]');
      if (box && box.dataset.amount === centsKey) return;
      const left = Math.max(0, TARGET - total);
      const progress = Math.max(0, Math.min(100, (total / TARGET) * 100));
      if (!box) {
        box = document.createElement('div');
        box.className = 'dos-cart-confidence';
        box.setAttribute('data-dos-drawer-confidence','');
        summary.prepend(box);
      }
      box.dataset.amount = centsKey;
      box.innerHTML = `
        <p class="dos-cart-confidence__eyebrow">Almost home</p>
        <strong class="dos-cart-confidence__headline">${total >= TARGET ? 'You reached the $50 free-shipping threshold.' : `You’re ${money(left)} away from the $50 free-shipping threshold.`}</strong>
        <p class="dos-cart-confidence__copy">${total >= TARGET ? 'Final shipping eligibility and available methods are confirmed at checkout.' : 'Mix and match qualifying finds from around the house.'}</p>
        <div class="dos-cart-progress" role="progressbar" aria-label="Free shipping progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(progress)}"><span style="width:${progress}%"></span></div>
        <div class="dos-cart-promises"><span>✓ 30-day no-hassle returns</span><span>✓ Secure checkout</span><span>✓ Final shipping shown before you place the order</span></div>
        <p class="dos-cart-confidence__house-rule">If something isn’t right, please tell us. We’d rather lose a sale than lose a relationship.</p>`;
    });
    removeOldViewDetails();
    enableImageDetails();
    renderCheckoutReassurance();
    renderSavings();
    fetchCart();
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(render);
  };

  document.addEventListener('click',(event) => {
    const media = event.target.closest('.dos-cart-media-link[data-dos-product-url]');
    if (media) { window.location.assign(media.dataset.dosProductUrl); return; }
    setTimeout(() => { fetchCart(true); schedule(); },180);
  });
  document.addEventListener('keydown',(event) => {
    const media = event.target.closest('.dos-cart-media-link[data-dos-product-url]');
    if (!media || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    window.location.assign(media.dataset.dosProductUrl);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => { schedule(); fetchCart(true); },{once:true});
  else { schedule(); fetchCart(true); }
  new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true,characterData:true});
})();